'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function ($templateCache) {
  "ngInject";

  console.log('run func', _templates2.default);
  for (var prod in _templates2.default) {
    var prodTemplates = _templates2.default[prod];
    for (var material in prodTemplates) {
      //console.log(material, `${prod}-${material}.html`);
      $templateCache.put(prod + '-' + material + '.html', _templates2.default[prod][material]);
    }
  }
};

var _templates = require('./components/material-pricing/templates');

var _templates2 = _interopRequireDefault(_templates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/run.js
 **/